/* eslint-disable jsx-a11y/anchor-is-valid */

import Pagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'
import TablePagination from '@mui/material/TablePagination'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponseLoading, useQueryResponsePagination} from '../../core/QueryResponseProvider'

const mappedLabel = (label: string): string => {
  if (label === '&laquo; Previous') {
    return 'Previous'
  }

  if (label === 'Next &raquo;') {
    return 'Next'
  }

  return label
}

const PartyLedgerListPagination = () => {
  const pagination = useQueryResponsePagination()
  const isLoading = useQueryResponseLoading()
  const {state, updateState} = useQueryRequest()
  const updatePage = (page: number | null) => {
    if (!page || isLoading || pagination.page === page) {
      return
    }

    updateState({page, perPage: pagination.perPage || 10})
  }

  return (
    <div className='row'>
      <div className='col-sm-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start'>
        {/* Displaying Total Records
        {pagination.total ? (
          <p className="mb-0">Total Records: <strong>{pagination.total}</strong></p>
        ) : null} */}
      </div>
      <div className='col-sm-12 col-md-8 d-flex align-items-center justify-content-center justify-content-md-end'>
        {pagination.total ? (
          <>
            <Stack spacing={2}>
              <Pagination
                count={pagination.totalPageNumber}
                defaultPage={1}
                page={pagination.page}
                showFirstButton
                showLastButton
                onChange={(e: any, p: any) => {
                  updateState({
                    page: p,
                    // , perPage: pagination.perPage || 10
                  })
                }}
              />
            </Stack>
            <TablePagination
              className='pt-3 cust-pagination'
              component='p'
              count={pagination.total}
              page={state.page - 1}
              onPageChange={(e: any) => {
                updateState({page: pagination.page, perPage: e.target.value})
              }}
              rowsPerPage={state.perPage}
              rowsPerPageOptions={[25, 50, 100, 150, 200]}
              onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const newPerPage = parseInt(event.target.value, 10)
                const totalPages = Math.ceil(pagination.total / newPerPage)
                let newPage = state.page

                // Check if the current page exceeds the new total number of pages
                if (newPage > totalPages) {
                  newPage = totalPages
                }

                updateState({page: newPage, perPage: newPerPage as 25 | 50 | 100 | 150 | 200})
              }}
              nextIconButtonProps={{style: {display: 'none'}}}
              backIconButtonProps={{style: {display: 'none'}}}
            />
          </>
        ) : (
          ''
        )}
      </div>
     
    </div>
  )
}

export {PartyLedgerListPagination}
